var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect7, _path8, _rect8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobotAsking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 148,
    viewBox: "0 0 191 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.8448,
    y: 4.28234,
    width: 119.477,
    height: 93.7833,
    rx: 14.56,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 8.56468
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2682,
    y: 9.42101,
    width: 106.63,
    height: 83.5056,
    rx: 14.56,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 8.56468
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5459,
    y: 20.127,
    width: 86.075,
    height: 61.6657,
    rx: 18.8423,
    fill: "#FDFFF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.8448,
    y: 4.28234,
    width: 119.477,
    height: 93.7833,
    rx: 14.56,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 8.56468
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 22.2682,
    y: 9.42101,
    width: 106.63,
    height: 83.5056,
    rx: 14.56,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 8.56468
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32.5459,
    y: 20.127,
    width: 86.075,
    height: 61.6657,
    rx: 18.8423,
    fill: "#FDFFF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9577,
    cy: 43.2514,
    r: 8.13645,
    fill: "#280003"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.7834,
    cy: 43.2514,
    r: 8.13645,
    fill: "#280003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.7833 65.3056C93.7833 66.239 93.2566 67.1631 92.2335 68.0245C91.2105 68.886 89.7114 69.6678 87.8229 70.3247C85.9344 70.9817 83.6939 71.5008 81.2307 71.852C78.7675 72.2033 76.1305 72.3797 73.472 72.3712C70.8135 72.3626 68.1861 72.1693 65.7417 71.8022C63.2972 71.4352 61.0842 70.9018 59.2302 70.2328C57.3763 69.5639 55.9183 68.7726 54.9403 67.9046C53.9624 67.0367 53.484 66.1094 53.5327 65.1762L62.091 65.2312C62.063 65.7676 62.338 66.3005 62.9 66.7993C63.462 67.2981 64.3 67.7529 65.3655 68.1373C66.4309 68.5218 67.7028 68.8284 69.1077 69.0393C70.5125 69.2502 72.0225 69.3614 73.5504 69.3663C75.0783 69.3712 76.5938 69.2698 78.0094 69.0679C79.425 68.866 80.7127 68.5677 81.798 68.1902C82.8834 67.8126 83.7449 67.3633 84.3329 66.8682C84.9208 66.3731 85.2235 65.842 85.2235 65.3056H93.7833Z",
    fill: "#280003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.92 120.803L109.432 121.653L110.282 123.14C116.028 133.204 128.845 136.704 138.909 130.957L142.627 128.834L144.115 127.984L143.265 126.497L133.71 109.762L132.86 108.275L131.373 109.124L110.92 120.803Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 3.42587
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M134.082 109.55L133.232 108.062L134.72 107.213L141.228 103.497C146.67 100.389 153.602 102.282 156.71 107.725C159.818 113.167 157.925 120.099 152.482 123.206L145.974 126.923L144.487 127.772L143.637 126.284L134.082 109.55Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 3.42587
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8354 101.491H123.332V163.157C123.332 166.705 120.456 169.581 116.908 169.581H34.259C30.7114 169.581 27.8354 166.705 27.8354 163.157V101.491Z",
    fill: "#280003"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0418 108.986H114.124V158.875C114.124 160.649 112.686 162.087 110.912 162.087H40.2536C38.4798 162.087 37.0418 160.649 37.0418 158.875V108.986Z",
    fill: "#C2D1D4",
    stroke: "#FFFEF2",
    strokeWidth: 6.42351
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M138.748 34.6868H143.03C146.578 34.6868 149.453 37.5627 149.453 41.1103V65.0914C149.453 68.639 146.578 71.5149 143.03 71.5149H138.748V34.6868Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 4.28234
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56477 32.546C5.01716 32.546 2.14126 35.4219 2.14126 38.9695V62.9506C2.14126 66.4982 5.01716 69.3741 8.56477 69.3741H12.8471V32.546H8.56477Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 4.28234
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8256,
    y: 169.153,
    width: 31.2611,
    height: 16.7011,
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 5.13881
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9429 187.138V185.425H70.23H42.823C37.1468 185.425 32.5454 190.027 32.5454 195.703V198.701V200.414H34.2583H70.23H71.9429V198.701V187.138Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 3.42587
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5694,
    y: -2.5694,
    width: 31.2611,
    height: 16.7011,
    transform: "matrix(-1 0 0 1 114.339 171.722)",
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 5.13881
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6518 187.138V185.425H81.3648H108.772C114.448 185.425 119.049 190.027 119.049 195.703V198.701V200.414H117.336H81.3648H79.6518V198.701V187.138Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 3.42587
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5479 110.913V109.2H27.835C16.2461 109.2 6.85152 118.594 6.85152 130.183V134.465V136.178H8.56445H27.835H29.5479V134.465V110.913Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 3.42587
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M27.835 136.607H29.5479V138.32V145.814C29.5479 152.081 24.4672 157.162 18.1997 157.162C11.9323 157.162 6.85152 152.081 6.85152 145.814V138.32V136.607H8.56445H27.835Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 3.42587
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.421 80.5531C188.816 81.0333 188.756 81.7449 188.285 82.1556C183.549 86.2898 160.302 106.582 153.674 112.369C153.209 112.774 152.602 112.975 151.99 112.926C151.379 112.877 150.814 112.582 150.423 112.107C150.424 112.107 150.423 112.107 150.423 112.107C150.033 111.633 149.85 111.018 149.916 110.404C149.982 109.79 150.292 109.227 150.774 108.843C157.595 103.417 181.362 84.5067 186.577 80.3568C187.143 79.9069 187.959 79.9915 188.416 80.5473C188.418 80.5493 188.42 80.5512 188.421 80.5531Z",
    fill: "#1388D8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.145 79.95C189.863 80.8239 189.754 82.1186 188.898 82.8658L154.286 113.079C153.63 113.651 152.774 113.935 151.911 113.866C151.048 113.796 150.251 113.38 149.7 112.71C149.149 112.041 148.891 111.174 148.984 110.308C149.078 109.441 149.514 108.647 150.195 108.105L185.998 79.6189C186.964 78.8505 188.359 78.9949 189.14 79.9442L189.145 79.95ZM187.698 81.1561L187.693 81.1503C187.56 80.9882 187.321 80.9636 187.156 81.0948L151.354 109.581C151.069 109.808 150.887 110.139 150.848 110.501C150.809 110.863 150.917 111.224 151.147 111.504C151.376 111.783 151.71 111.958 152.07 111.987C152.43 112.016 152.788 111.897 153.062 111.658L187.673 81.4452C187.758 81.371 187.769 81.2428 187.698 81.1561Z",
    fill: "#280003"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.145 79.95C189.863 80.8239 189.754 82.1186 188.898 82.8658L154.286 113.079C153.63 113.651 152.774 113.935 151.911 113.866C151.048 113.796 150.251 113.38 149.7 112.71C149.149 112.041 148.891 111.174 148.984 110.308C149.078 109.441 149.514 108.647 150.195 108.105L185.998 79.6189C186.964 78.8505 188.359 78.9949 189.14 79.9442L189.145 79.95ZM187.698 81.1561L187.693 81.1503C187.56 80.9882 187.321 80.9636 187.156 81.0948L151.354 109.581C151.069 109.808 150.887 110.139 150.848 110.501C150.809 110.863 150.917 111.224 151.147 111.504C151.376 111.783 151.71 111.958 152.07 111.987C152.43 112.016 152.788 111.897 153.062 111.658L187.673 81.4452C187.758 81.371 187.769 81.2428 187.698 81.1561Z",
    fill: "#280003"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotAsking);
export default __webpack_public_path__ + "static/media/RobotAsking.7363ec9cf0270a0a3a7daa6ddabacac1.svg";
export { ForwardRef as ReactComponent };